import { brandedUuid } from '../FlavorSchema.js';
export const UserIdSchema = brandedUuid('Invalid user ID format');
/**
 * @deprecated Use SystemActorAuditContext with actorType: 'system' instead.
 * System operations should not pass a userId - it will be stored as null in the database.
 * This constant causes FK constraint violations since it doesn't exist in organizationUsers.
 */
export const SYSTEM_USER_ID = '00000000-0000-0000-0000-000000000000';
//# sourceMappingURL=UserSchemas.js.map